(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["TT-knowledged-hub"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {


const library = document.querySelector('[data-tiny-teachables]');


if (!library) {
return;
}



const sectionId = library.dataset.sectionId;


const animalFilters =
library.querySelectorAll('[data-animal-filter]');


const topicFilters =
library.querySelectorAll('[data-topic-filter]');


const cardsContainer =
library.querySelector('[data-article-grid]');


const resultsCount =
library.querySelector('[data-results-count]');


const noResults =
library.querySelector('[data-no-results]');


const clearButtons =
library.querySelectorAll('[data-clear-filters]');


function getFilters(){


let animals = [];


animalFilters.forEach(function(filter){

if(filter.checked){

animals.push(
filter.value.toLowerCase()
);

}

});



let topics = [];


topicFilters.forEach(function(filter){

if(filter.checked){

topics.push(
filter.value.toLowerCase()
);

}

});


return {
animals: animals,
topics: topics
};


}




function matchesFilters(card, filters){


const animals =
(card.dataset.animalTags || '')
.toLowerCase();


const topics =
(card.dataset.topicTags || '')
.toLowerCase();



const animalMatch =

filters.animals.length === 0 ||

filters.animals.some(function(animal){

return animals.includes(animal);

});



const topicMatch =

filters.topics.length === 0 ||

filters.topics.some(function(topic){

return topics.includes(topic);

});



return animalMatch && topicMatch;


}





function applyFilters(){


const filters = getFilters();


const cards =
library.querySelectorAll('[data-article-card]');


let visible = 0;



cards.forEach(function(card){


if(matchesFilters(card,filters)){


card.hidden=false;

visible++;


}else{


card.hidden=true;


}


});




if(resultsCount){


resultsCount.textContent =

visible === 1

?

'Showing 1 article'

:

'Showing ' + visible + ' articles';


}



if(noResults){


noResults.hidden = visible !== 0;


}


}






animalFilters.forEach(function(filter){

filter.addEventListener(
'change',
applyFilters
);

});



topicFilters.forEach(function(filter){

filter.addEventListener(
'change',
applyFilters
);

});






clearButtons.forEach(function(button){


button.addEventListener(
'click',
function(){


animalFilters.forEach(function(filter){

filter.checked=false;

});


topicFilters.forEach(function(filter){

filter.checked=false;

});


applyFilters();


}
);


});






const loadMore =
library.querySelector('[data-load-more]');



if(loadMore){


loadMore.addEventListener(
'click',
function(){


const url =
loadMore.dataset.nextUrl;


if(!url){
return;
}



loadMore.disabled=true;


fetch(
url +
(url.includes('?') ? '&' : '?') +
'sections=' +
sectionId
)


.then(function(response){

return response.json();

})


.then(function(data){


const html =
data[sectionId];


if(!html){
return;
}



const parser =
new DOMParser();



const parsed =
parser.parseFromString(
html,
'text/html'
);



const newCards =
parsed.querySelectorAll(
'[data-article-card]'
);



newCards.forEach(function(card){

cardsContainer.appendChild(card);

});



const newButton =
parsed.querySelector('[data-load-more]');



const wrapper =
library.querySelector('[data-load-more-wrapper]');



if(wrapper){


if(newButton){

wrapper.innerHTML =
newButton.parentElement.innerHTML;


}else{

wrapper.remove();

}


}



applyFilters();



})


.catch(function(error){

console.error(error);

loadMore.disabled=false;

});


}
);


}




applyFilters();


});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
